/**
 * @pageName BookingsServiceForm
 * @slotType dashboard plugin
 */
export type ServiceFormSectionProps = {
  serviceId?: string;
  save: () => Promise<
    { success: true; serviceId: string } | { success: false; errors: unknown }
  >;
};
/**
 * @pageName BookingsServiceForm
 * @slotType dashboard plugin
 */
export type ServiceFormSidebarProps = {
  serviceId?: string;
  save: () => Promise<
    { success: true; serviceId: string } | { success: false; errors: unknown }
  >;
};
/**
 * @pageName BookingsServiceForm
 * @slotType dashboard menu plugin
 */
export type ServiceFormMoreActionsMenuProps = {
  serviceId?: string;
  save: () => Promise<
    { success: true; serviceId: string } | { success: false; errors: unknown }
  >;
};
